module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/readable-stream@2.3.8/~/readable-stream/transform.js
// module id = 673
// module chunks = 0